<template>
    <div class="personalities-media-publications">
        <div class="d-flex">
            <div class="personalities-title text-left">
                Публикации в СМИ
            </div>
            <div class="ml-auto mt-2">
                <svg-icon
                @click="svgClick"
                :svgData="svgData"/>
            </div>
        </div>
        <div v-if="this.open">
            <div class="text-left mt-5" v-for="publication in media_publications" :key="publication.text">
                <a class="personalities-file-name" :href="publication.href" target="_blank">{{publication.text}}</a>
            </div>
        </div>
        <div class="personalities-border mt-6"></div>
    </div>
    <div class="personalities-edit" v-if="can_edit_personality">
      <v-container class="ma-0 pa-0 mt-10" fluid>
        <v-row v-for="(file, key) in media_publications" :key="key">
            <v-col cols=5>
                <v-text-field
                    class="mr-4"
                    label="Ссылка"
                    :model-value="getMediaPublicationItemHref(key)"
                    @update:model-value="newValue => setMediaPublicationItemHref(key, newValue)">
                </v-text-field>
            </v-col>
            <v-col cols=5>
                <v-text-field
                    class="mr-4"
                    label="Текст ссылки"
                    :model-value="getMediaPublicationItemText(key)"
                    @update:model-value="newValue => setMediaPublicationItemText(key, newValue)">
                </v-text-field>
            </v-col>
            <v-col cols =2>
                <v-btn
                @click="delItem(key)"
                >
                Удалить
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols=12>
                <v-btn @click="addItem">
                    Добавить
                </v-btn>
            </v-col>
        </v-row>
      </v-container>
    </div>
</template>
<script>

import SvgIcon from '@/components/content/SvgIcon.vue'
import { useUserStore } from '@/store/user';
import { useAuthStore } from '@/store/auth';

export default{
    name: 'PersonalitiesScienceAchievements',
    components: {
        SvgIcon,
    },
    data () {
            return {
                open: true,
                svgData: {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    pathArr: [{
                        d: "M23.6673 13.6668H13.6673V23.6668H10.334V13.6668H0.333984V10.3335H10.334V0.333496H13.6673V10.3335H23.6673V13.6668Z",
                        fill: "#3B66D3"
            }]
        }
      }
    },
    computed:{
        media_publications: {
            get(){
                const userStore = useUserStore()
                if (userStore.changeUser.media_publications)
                    return userStore.changeUser.media_publications 
                return []
            }
        },
        can_edit_personality() {
            let AuthStore = useAuthStore()
            return AuthStore.can_edit_personality
        }
    },
    methods: {
        svgClick() {
            this.open=!this.open
        },
        getMediaPublicationItemHref(index){
            return this.media_publications[index].href
        },
        getMediaPublicationItemText(index){
            return this.media_publications[index].text
        },
        setMediaPublicationItemHref(index, newValue){
            this.media_publications[index].href = newValue
        },
        setMediaPublicationItemText(index, newValue){
            this.media_publications[index].text = newValue
        },
        addItem(){
            const userStore = useUserStore()
            if (!userStore.changeUser.media_publications){
                userStore.changeUser.media_publications = []
            }
            userStore.changeUser.media_publications.push({"href":"",
            "text":""})
        },
        delItem(i){
            const userStore = useUserStore()
            userStore.changeUser.media_publications.splice(i,1)
        }
    }
}
</script>